import './js/image-search';
import './sass/main.scss';